<div class="flex-column h-100">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@gasWarningCenterConfiguration.selectGasWarningCenter.dashboards.header"
      data-testid="gasWarningCenterConfiguration.selectGasWarningCenter.dashboards.header"
    >
      Dashboards auswählen
    </h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (filteredDashboards(); as dashboards) {
      @if (dashboards.length > 0) {
        <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100">
          @for (dashboard of dashboards; track dashboard.id) {
            <app-product-card-with-quantity
              class="overflow-hidden"
              [productData]="dashboard"
              [showCosts]="project.showCostFlag"
              selectionMode="multi"
              [quantity]="getSelectedQuantity(dashboard)"
              (quantityChanged$)="updateSelectedDashboards($event, dashboard)"
            >
              @if (dashboard.id) {
                <div class="feature">
                  <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                  <p class="odx-text--small">{{ dashboard.id }}</p>
                </div>
              }
            </app-product-card-with-quantity>
          }
        </div>
      } @else {
        <app-refresh-products-hint dataType="Dashboards" i18n-dataType="@@global.dashboards"></app-refresh-products-hint>
      }
    }
  </odx-content-box>
</div>
